export const ContactInformation = (): JSX.Element => {
    return (
        <div className="has-background-success-light pt-4 px-6">
            <div className="pb-4">
                <div className="has-text-grey-darker has-text-weight-semibold pb-2">i-Function, Inc.</div>
                <div className="py-1">1951 NW 7th Avenue, Suite 300</div>
                <div className="py-1">
                    <span>Email: </span>
                    <a className="is-underlined" href={"mailto:info@i-Function.com"} target="_blank" rel="noreferrer">
                        info@i-Function.com
                    </a>
                </div>
                <div className="py-1">
                    <a className="is-underlined" href={"https://i-function.com/"} target="_blank" rel="noreferrer">
                        https://i-function.com/
                    </a>
                </div>
            </div>
        </div>
    );
};
